var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{ref:"aside",staticClass:"d-flex side-nav"},[_c('nav',{ref:"navbar-aside",staticClass:"py-3 px-2 d-flex flex-column align-items-center navbar-aside"},[_c('ul',{staticClass:"nav nav-body w-100 flex-column"},_vm._l((_vm.links),function(link){return _c('NavLink',_vm._b({key:link.name,on:{"link":_vm.navClick}},'NavLink',link,false))}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }